// @flow

import type { FormErrors } from '@globalTypes';

import {
  EDUCATIONS_REQUEST,
  EDUCATIONS_REQUESTED,
  EDUCATIONS_REQUESTED_ERROR,
  EDUCATION_CREATE,
  EDUCATION_CREATED,
  EDUCATION_CREATED_ERROR,
  EDUCATION_RESET,
  EDUCATION_DELETE,
  EDUCATION_DELETED,
  EDUCATION_DELETED_ERROR,
  EDUCATION_UPDATE,
  EDUCATION_UPDATED,
  EDUCATION_UPDATED_ERROR
} from './constants';

import type {
  ResetAction,
  GetAction,
  CreateAction,
  UpdateAction,
  DeleteAction,
  Education,
  Educations
} from '../types';

export const requestEducations = (): GetAction => ({
  type: EDUCATIONS_REQUEST
});

export const updateEducations = (data: Educations): GetAction => ({
  type: EDUCATIONS_REQUESTED,
  data
});

export const errorEducations = (error: Error): GetAction => ({
  type: EDUCATIONS_REQUESTED_ERROR,
  error
});

export const createEducation = (data: Education): CreateAction => ({
  type: EDUCATION_CREATE,
  data
});

export const createdEducation = (): CreateAction => ({
  type: EDUCATION_CREATED
});

export const errorCreateEducation = (error: FormErrors): CreateAction => ({
  type: EDUCATION_CREATED_ERROR,
  error
});

export const updateEducation = (id: string, data: Education): UpdateAction => ({
  type: EDUCATION_UPDATE,
  data,
  id
});

export const updatedEducation = (id: string): UpdateAction => ({
  type: EDUCATION_UPDATED,
  id
});

export const errorUpdateEducation = (id: string, error: FormErrors): UpdateAction => ({
  type: EDUCATION_UPDATED_ERROR,
  error,
  id
});

export const deleteEducation = (id: string): DeleteAction => ({
  type: EDUCATION_DELETE,
  id
});

export const deletedEducation = (id: string): DeleteAction => ({
  type: EDUCATION_DELETED,
  id
});

export const errorDeletedEducation = (id: string, error: Error): DeleteAction => ({
  type: EDUCATION_DELETED_ERROR,
  error,
  id
});

export const resetEducation = (): ResetAction => ({ type: EDUCATION_RESET });
